import React from "react";
import { useUserAuth } from "../../../contexts/UserAuthContext";
import { useToast } from "../../../contexts/ToastContext";
import SettingsForm from "../../../components/profile/SettingsForm";
import EmailPreferencesSection from "../../../components/profile/EmailPreferencesSection";
import BlockedUsersSection from "../../../components/profile/BlockedUsersSection";
import AccountDeletionSection from "../../../components/profile/AccountDeletionSection";
import SettingsFormSkeleton from "../../../components/profile/SettingsFormSkeleton";
import CollapsibleSection from "../../../components/common/CollapsibleSection";
import ExpertApplicationSection from "../../../components/profile/ExpertApplicationSection";
import {
  FaExclamationTriangle,
  FaBan,
  FaGraduationCap,
  FaSlidersH,
} from "react-icons/fa";
import MatchPersonalizationSection from "../../../components/profile/MatchPersonalizationSection";
import styles from "../../../styles/pages/profile/SharedProfile.module.css";
import profileStyles from "../../../styles/pages/profile/ProfilePage.module.css";

/**
 * SettingsPage - User settings and preferences
 */
const SettingsPage = () => {
  const { user, setUser, logout } = useUserAuth();
  const { showToast } = useToast();

  return (
    <div className={styles.contentSection}>
      {!user ? (
        <SettingsFormSkeleton />
      ) : (
        <>
          <SettingsForm
            user={user}
            setUser={setUser}
            showToast={showToast}
            logout={logout}
          />
          <div className={profileStyles.settingsPageSections}>
            <EmailPreferencesSection showToast={showToast} />
            <CollapsibleSection
              title="Match personalization"
              subtitle="How Simpary tailors match scores — resets only, no technical details"
              titleIcon={<FaSlidersH className={profileStyles.sectionIcon} />}
              defaultExpanded={false}
            >
              <MatchPersonalizationSection showToast={showToast} />
            </CollapsibleSection>
            <CollapsibleSection
              title="Verified Expert Program"
              subtitle="Apply to become a Simpary Verified Expert"
              titleIcon={<FaGraduationCap className={profileStyles.sectionIcon} />}
              defaultExpanded={false}
            >
              <ExpertApplicationSection showToast={showToast} />
            </CollapsibleSection>
            <CollapsibleSection
              title="Blocked Users"
              subtitle="Manage users you've blocked"
              titleIcon={<FaBan className={profileStyles.sectionIcon} />}
              defaultExpanded={false}
            >
              <BlockedUsersSection />
            </CollapsibleSection>
            <CollapsibleSection
              title="Danger Zone"
              subtitle="Account deletion and data management"
              titleIcon={<FaExclamationTriangle className={profileStyles.sectionIcon} />}
              variant="danger"
              defaultExpanded={false}
            >
              <AccountDeletionSection
                user={user}
                showToast={showToast}
                logout={logout}
              />
            </CollapsibleSection>
          </div>
        </>
      )}
    </div>
  );
};

export default SettingsPage;
